// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Global styles for Tool Tip components
 */
.ad-global-tooltip {
    position: absolute;
    background-color: #1a3289 !important;
    font-family: 'Roboto-Medium', serif !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 22px !important;
    color: #ffffff !important;
    padding: 2px 8px !important;
    border-radius: 4px !important;
    box-shadow: 0 4px 16px rgba(78, 93, 120, 0.56) !important;
}
.ad-global-tooltip.place-bottom:after {
    border-bottom-color: #1a3289 !important;
    border-bottom-style: solid !important;
    border-bottom-width: 6px !important;
}
.ad-global-tooltip.place-top:after {
    border-top-color: #1a3289 !important;
    border-top-style: solid !important;
    border-top-width: 6px !important;
}
.ad-global-tooltip.place-left:after {
    border-left-color: #1a3289 !important;
    border-left-style: solid !important;
    border-left-width: 6px !important;
}
.ad-global-tooltip.place-right:after {
    border-right-color: #1a3289 !important;
    border-right-style: solid !important;
    border-right-width: 6px !important;
}
/**
 * END - Global styles for Tool Tip components
 */
`, "",{"version":3,"sources":["webpack://./assets/css/GlobalStyles.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,kBAAkB;IAClB,oCAAoC;IACpC,8CAA8C;IAC9C,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,yDAAyD;AAC7D;AACA;IACI,uCAAuC;IACvC,qCAAqC;IACrC,mCAAmC;AACvC;AACA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,gCAAgC;AACpC;AACA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,iCAAiC;AACrC;AACA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,kCAAkC;AACtC;AACA;;EAEE","sourcesContent":["/**\n * Global styles for Tool Tip components\n */\n.ad-global-tooltip {\n    position: absolute;\n    background-color: #1a3289 !important;\n    font-family: 'Roboto-Medium', serif !important;\n    font-weight: 500 !important;\n    font-size: 14px !important;\n    line-height: 22px !important;\n    color: #ffffff !important;\n    padding: 2px 8px !important;\n    border-radius: 4px !important;\n    box-shadow: 0 4px 16px rgba(78, 93, 120, 0.56) !important;\n}\n.ad-global-tooltip.place-bottom:after {\n    border-bottom-color: #1a3289 !important;\n    border-bottom-style: solid !important;\n    border-bottom-width: 6px !important;\n}\n.ad-global-tooltip.place-top:after {\n    border-top-color: #1a3289 !important;\n    border-top-style: solid !important;\n    border-top-width: 6px !important;\n}\n.ad-global-tooltip.place-left:after {\n    border-left-color: #1a3289 !important;\n    border-left-style: solid !important;\n    border-left-width: 6px !important;\n}\n.ad-global-tooltip.place-right:after {\n    border-right-color: #1a3289 !important;\n    border-right-style: solid !important;\n    border-right-width: 6px !important;\n}\n/**\n * END - Global styles for Tool Tip components\n */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
